import { render } from "./PpcAuthDetail.vue?vue&type=template&id=5c4c8834"
import script from "./PpcAuthDetail.vue?vue&type=script&lang=js"
export * from "./PpcAuthDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__